import React from 'react'
import { getImages } from '../components/Common/const'
import MarkBrand from '../components/Common/MarkBrand'
import { Link } from 'react-router-dom'

const FinanceCenter = () => {
    return (
        <>
            <section className='common-banner-wrap mob-h-240 position-relative'>
                <img src={getImages('finance-hero.webp')} />
                <div className='cb-pos'>
                    <div className='xl-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Finance Center</div>
                    <div className='mt-5 text-center cb-title wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.8s">
                        <Link to="/applyforcredit-boerne" className='btn-theme text-gray w-330 d-inline-block me-md-4 mb-md-0 mb-3'>CREDIT APPLICATION - BOERNE</Link>
                        <Link to="/applyforcredit-austin" className='btn-theme text-gray w-330 d-inline-block'>CREDIT APPLICATION - AUSTIN</Link>
                    </div>
                </div>
            </section>
            <section className='finance-wrap'>
                <div className='container'>
                    <div className='md-title font-2-2em pe-md-5 text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">OUR LENDER NETWORK IS AVAILABLE TO ENSURE YOU GET THE <span className='text-theme'>BEST RATE</span> AVAILABLE.
                    </div>
                    <div className='mt-md-5 mt-4'>
                        <div className='row g-xl-5 g-lg-4 g-3'>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo1.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo2.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo3.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo4.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo5.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo6.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('PNC-Bank-logo.png')} />
                                </div>
                            </div>
                            <div className='col-md-3 col-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                                <div className='finance-box'>
                                    <img src={getImages('finance-logo8.png')} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='simple-process-wrap'>
                <div className='container'>
                    <div className='md-title font-2-2em text-uppercase text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.5s">Simple Process</div>
                    <div className='mt-md-4 mt-3 row g-xl-5 g-lg-4 g-3'>
                        <div className='col-md-4 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                            <div className='cr-box sp-box'>
                                <div className='w-100'>
                                    <div className='sp-circle'>1</div>
                                    <div className='md-title font-1-5em mb-3 text-uppercase text-center'>Fill Online Form</div>
                                    <p className='opacity-0-7'>Apply now by providing enough information for our preferred lenders to compete for your loan.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.8s">
                            <div className='cr-box sp-box'>
                                <div className='w-100'>
                                    <div className='sp-circle'>2</div>
                                    <div className='md-title font-1-5em mb-3 text-uppercase text-center'>We Shop For You</div>
                                    <p className='opacity-0-7'>Our determined finance team will ensure that you will get the best available rate possible.</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-4 wow fadeInUp' data-wow-duration="1s" data-wow-delay="1s">
                            <div className='cr-box sp-box'>
                                <div className='w-100'>
                                    <div className='sp-circle'>3</div>
                                    <div className='md-title font-1-5em mb-3 text-uppercase text-center'>Take Delivery</div>
                                    <p className='opacity-0-7'>We deliver nationwide. Let us get your new exotic loaded up and headed to you today.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='sc-services-wrap'>
                <div className='container'>
                    <div className='ss-box cr-box mt-md-4 mb-md-4 mt-0'>
                        <div className='md-title text-uppercase text-center wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.4s">begin the rapid online application.</div>
                        <div className='text-center mt-5 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.7s">
                            <Link to="/applyforcredit-boerne" className='btn-theme text-gray w-330 d-inline-block me-md-4 mb-md-0 mb-3'>CREDIT APPLICATION - BOERNE</Link>
                            <Link to="/applyforcredit-austin" className='btn-theme text-gray w-330 d-inline-block'>CREDIT APPLICATION - AUSTIN</Link>
                        </div>
                    </div>
                </div>
            </section>
            {/* <MarkBrand/> */}
        </>
    )
}

export default FinanceCenter